import { Helmet } from "react-helmet-async";

const BASE_URL = "https://www.openmatic.cl";
const DEFAULT_IMAGE = "/og-image.png";
const DEFAULT_DESCRIPTION =
  "OpenMatic - Tu tienda vending online. Compra productos de tus máquinas favoritas con delivery o retiro, pagos con WebPay o OneClick.";

export const SEO = ({
  title,
  description = DEFAULT_DESCRIPTION,
  image = DEFAULT_IMAGE,
  url,
  type = "website",
  noIndex = false,
}) => {
  const fullTitle = title
    ? `${title} | OpenMatic`
    : "OpenMatic - Tu tienda vending online";
  const fullImage = image.startsWith("http") ? image : `${BASE_URL}${image}`;
  const canonical = url ? `${BASE_URL}${url}` : undefined;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      {canonical && <link rel="canonical" href={canonical} />}

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:type" content={type} />
      {canonical && <meta property="og:url" content={canonical} />}

      {/* Twitter */}
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />
    </Helmet>
  );
};
